<template>
  <section v-for="section in library.children" :key="section.id">
    <heading tag="h2" icon="library">{{ section.title }}</heading>
    <div class="elements">
      <LbButtonShelf
        v-for="child in section.children"
        :key="child.id"
        class="item"
        :color="child.colorCode || section.colorCode"
        :to="`${libraryStrategy.path.value}/${child.slug}`"
        :title="child.title"
      >
      </LbButtonShelf>
    </div>
  </section>
</template>
<script lang="ts" setup>
const route = useRoute();

const {
  libraryManager: { library },
  libraryStrategy,
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);
</script>
<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.elements {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  column-gap: 1.5rem;
  row-gap: 1.5rem;
  @include above('m') {
    grid-template-columns: repeat(3, 1fr);
  }
  @include above('xl') {
    grid-template-columns: repeat(4, 1fr);
  }

  .template-content-aside & {
    @include above('xl') {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

.item {
  align-self: stretch;
}
</style>
